// Sistema de Tipografia Padronizado
// Baseado em uma escala modular de 1.25 (quarta)
// Famílias de fonte
export const fontFamily = {
  primary: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif",
  secondary: "'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
  mono: "'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace"
}; // Pesos de fonte

export const fontWeight = {
  light: 300,
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800
}; // Tamanhos de fonte (em px)

export const fontSize = {
  xs: '10px',
  sm: '12px',
  base: '14px',
  lg: '16px',
  xl: '18px',
  '2xl': '20px',
  '3xl': '24px',
  '4xl': '28px',
  '5xl': '32px',
  '6xl': '36px',
  '7xl': '42px',
  '8xl': '48px'
}; // Alturas de linha

export const lineHeight = {
  none: 1,
  tight: 1.25,
  snug: 1.375,
  normal: 1.5,
  relaxed: 1.625,
  loose: 2
}; // Espaçamento entre letras

export const letterSpacing = {
  tighter: '-0.05em',
  tight: '-0.025em',
  normal: '0em',
  wide: '0.025em',
  wider: '0.05em',
  widest: '0.1em'
}; // Estilos de texto pré-definidos

export const textStyles = {
  // Títulos
  h1: {
    fontSize: fontSize['6xl'],
    lineHeight: lineHeight.tight,
    fontWeight: fontWeight.bold,
    letterSpacing: letterSpacing.tight
  },
  h2: {
    fontSize: fontSize['5xl'],
    lineHeight: lineHeight.tight,
    fontWeight: fontWeight.bold,
    letterSpacing: letterSpacing.tight
  },
  h3: {
    fontSize: fontSize['4xl'],
    lineHeight: lineHeight.snug,
    fontWeight: fontWeight.semibold,
    letterSpacing: letterSpacing.normal
  },
  h4: {
    fontSize: fontSize['3xl'],
    lineHeight: lineHeight.snug,
    fontWeight: fontWeight.semibold,
    letterSpacing: letterSpacing.normal
  },
  h5: {
    fontSize: fontSize['2xl'],
    lineHeight: lineHeight.normal,
    fontWeight: fontWeight.medium,
    letterSpacing: letterSpacing.normal
  },
  h6: {
    fontSize: fontSize.xl,
    lineHeight: lineHeight.normal,
    fontWeight: fontWeight.medium,
    letterSpacing: letterSpacing.normal
  },
  // Texto do corpo
  body: {
    fontSize: fontSize.base,
    lineHeight: lineHeight.relaxed,
    fontWeight: fontWeight.regular,
    letterSpacing: letterSpacing.normal
  },
  bodyLarge: {
    fontSize: fontSize.lg,
    lineHeight: lineHeight.relaxed,
    fontWeight: fontWeight.regular,
    letterSpacing: letterSpacing.normal
  },
  bodySmall: {
    fontSize: fontSize.sm,
    lineHeight: lineHeight.normal,
    fontWeight: fontWeight.regular,
    letterSpacing: letterSpacing.normal
  },
  // Texto de interface
  caption: {
    fontSize: fontSize.xs,
    lineHeight: lineHeight.normal,
    fontWeight: fontWeight.regular,
    letterSpacing: letterSpacing.wide
  },
  button: {
    fontSize: fontSize.base,
    lineHeight: lineHeight.none,
    fontWeight: fontWeight.medium,
    letterSpacing: letterSpacing.wide
  },
  label: {
    fontSize: fontSize.sm,
    lineHeight: lineHeight.normal,
    fontWeight: fontWeight.medium,
    letterSpacing: letterSpacing.normal
  },
  // Texto de destaque
  display: {
    fontSize: fontSize['8xl'],
    lineHeight: lineHeight.tight,
    fontWeight: fontWeight.extrabold,
    letterSpacing: letterSpacing.tighter
  },
  lead: {
    fontSize: fontSize.xl,
    lineHeight: lineHeight.relaxed,
    fontWeight: fontWeight.regular,
    letterSpacing: letterSpacing.normal
  }
}; // Função helper para aplicar estilos de texto

export const applyTextStyle = style => {
  const textStyle = textStyles[style];

  if (!textStyle) {
    console.warn(`Estilo de texto "${style}" não encontrado`);
    return textStyles.body;
  }

  return `
    font-family: ${fontFamily.primary};
    font-size: ${textStyle.fontSize};
    line-height: ${textStyle.lineHeight};
    font-weight: ${textStyle.fontWeight};
    letter-spacing: ${textStyle.letterSpacing};
  `;
}; // Função helper para criar variantes responsivas

export const responsiveText = (mobileStyle, tabletStyle, desktopStyle) => `
  ${applyTextStyle(mobileStyle)}
  
  @media (min-width: 768px) {
    ${applyTextStyle(tabletStyle || mobileStyle)}
  }
  
  @media (min-width: 1024px) {
    ${applyTextStyle(desktopStyle || tabletStyle || mobileStyle)}
  }
`;
export default {
  fontFamily,
  fontWeight,
  fontSize,
  lineHeight,
  letterSpacing,
  textStyles,
  applyTextStyle,
  responsiveText
};